module.exports = __webpack_public_path__ + "app/modals/set-speed-display.view-5x7.html";